<!-- Start Categories List -->
<div class="collection-collapse-block border-0" [class.open]="collapse">
    <h3 class="collapse-block-title">Category</h3>
    <div class="collection-collapse-block-content">
        <div class="collection-brand-filter">
            <ul class="category-list">
                <li style="font-weight: 800; font-size: 20px;">
                    <a [routerLink]="['/shop/collection/left/sidebar']" (click)="toggleEvent('all')">
                        All</a> 
                </li>
                <li *ngFor="let category of filterbyCategory" (click)="toggleEvent(category)">
                    <a [routerLink]="['/shop/collection/left/sidebar']" [queryParams]="{ category: category}">
                        <span [ngClass]="currentCategory === category ? 'bold' : 'default'">{{ category }}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>
<!-- End Categories List -->